import { createAction } from 'redux-actions';

export const GET_ALL_DATA = 'APP.GET_ALL_DATA';
export const getAllData = createAction(GET_ALL_DATA);

export const SET_FILTERS = 'APP.SET_FILTERS';
export const setFilters = createAction(SET_FILTERS);

export const DOWNLOAD_SPREADSHEET = 'APP.DOWNLOAD_SPREADSHEET';
export const downloadSpreadsheet = createAction(DOWNLOAD_SPREADSHEET);

export const SET_CLIENT_IDS = 'APP.SET_CLIENT_IDS';
export const setClientIds = createAction(SET_CLIENT_IDS);

export const PATH_AND_STATE_MISMATCH = 'APP.PATH_AND_STATE_MISMATCH';
export const pathAndStateMismatch = createAction(PATH_AND_STATE_MISMATCH);
